// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2gcv6","header":"ClearentDisclaimer_header__-xSWn","inner":"ClearentDisclaimer_inner__3N574"};